import { createAction } from '@reduxjs/toolkit';

export const userLogout = createAction('USER_LOGOUT');
